// Uniform VT API helper. Unlike @ui-seeker/utils.postSubmit, this does NOT
// reject on non-2xx — it always returns {ok, data, error} so callers can toast
// a useful message whatever happened.
//
// Sends credentials on every call so the Flask-Login session cookie travels
// with the request (the default `fetch` + signals helpers don't always do it).

async function call(method, path, body) {
	const opts = {
		method,
		credentials: 'include',
		headers: { 'Accept': 'application/json' },
	}
	if (body !== undefined && body !== null) {
		opts.headers['Content-Type'] = 'application/json'
		opts.body = JSON.stringify(body)
	}
	let res
	try {
		res = await fetch(path, opts)
	} catch (networkErr) {
		return { ok: false, status: 0, error: networkErr.message || 'Network error', data: null }
	}
	const txt = await res.text()
	let data = null
	try { data = txt ? JSON.parse(txt) : null } catch {}
	if (!res.ok) {
		const msg = (data && data.error) || txt || `HTTP ${res.status}`
		return { ok: false, status: res.status, error: msg, data }
	}
	return { ok: true, status: res.status, data }
}

export const vtApi = {
	get:   (p)       => call('GET', p),
	post:  (p, body) => call('POST', p, body || {}),
	patch: (p, body) => call('PATCH', p, body || {}),
	del:   (p)       => call('DELETE', p),
}
